<template>
  <section class="base-card" :class="[`base-card--${tone}`]">
    <slot />
  </section>
</template>

<script>
export default {
  name: 'BaseCard',
  props: {
    tone: {
      type: String,
      default: 'default',
    },
  },
};
</script>

<style scoped src="./BaseCard.css"></style>
